import { createSelector } from '@reduxjs/toolkit';
import { FENIX_FLOW_STATUS, HISTORY_STATUS, getLatestAttempt } from 'utils/fenixYms';

const EMPTY_ATTEMPTS = [];

const DEFAULT_ENTRY = {
    requestId: null,
    status: FENIX_FLOW_STATUS.IDLE,
    fenixSubmissionResult: null,
    exportButtonLocked: false,
    ymsUrl: null,
    ymsDetails: null,
    statusMessage: null,
    attempts: EMPTY_ATTEMPTS,
    historyStatus: HISTORY_STATUS.IDLE,
    localPendingId: null,
};

export const selectFenixYmsSlice = (state) => state.fenixYms;

export const selectFenixEntryByTransactionId = (id) =>
    createSelector(
        [selectFenixYmsSlice, (_, transactionId = id) => transactionId],
        (slice, transactionId) => slice.byTransactionId?.[transactionId] || DEFAULT_ENTRY
    );

export const selectFenixAttemptsByTransactionId = (id) =>
    createSelector([selectFenixEntryByTransactionId(id)], (entry) => entry.attempts || EMPTY_ATTEMPTS);

export const selectFenixIsInProgressByTransactionId = (id) =>
    createSelector([selectFenixEntryByTransactionId(id)], (entry) => entry.status === FENIX_FLOW_STATUS.IN_PROGRESS);

export const selectFenixExportButtonLockedByTransactionId = (id) =>
    createSelector([selectFenixEntryByTransactionId(id)], (entry) => entry.exportButtonLocked);

export const selectFenixExportStatusByTransactionId = (id) =>
    createSelector([selectFenixAttemptsByTransactionId(id)], (attempts) => {
        const latest = getLatestAttempt(attempts);
        return latest?.status ?? null;
    });

export const selectFenixYmsUrlByTransactionId = (id) => createSelector([selectFenixEntryByTransactionId(id)], (entry) => entry.ymsUrl);

export const selectFenixHistoryStatusByTransactionId = (id) => createSelector([selectFenixEntryByTransactionId(id)], (entry) => entry.historyStatus);

export const selectIsTabActivationPendingByTransactionId = (id) =>
    createSelector(
        [selectFenixYmsSlice, (_, transactionId = id) => transactionId],
        (slice, transactionId) => !!slice.pendingTabActivations?.[transactionId]
    );
